import {
  AppLayout as AppLayoutComponent,
  Logo,
  Menu,
  MenuItem,
  Spacer,
  useTheme
} from '@convergence/components';
import { Books, User } from '@phosphor-icons/react';
import React, { useState } from 'react';
import { Outlet } from 'react-router';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { fetch } from '../../api/fetch';
import { useLogoutMutation } from '../../api/mutations/logout';
import { AssumeRole } from '../../components/AssumeRole';
import { useAuthContext } from '../../components/AuthProvider';
import { Dev } from '../../components/Dev';
import { config } from '../../config';
import { useKeyboardShortcut } from '../../hooks/useShortcut';
import { hasRole } from '../../lib/hasRole';
import gobble from '../../assets/turkey-trimmed.mp3';
import { AppMenu } from './AppMenu';

export const AppLayout: React.FC = () => {
  const [sideBarVisible, setSideBarVisible] = useState(true);
  const { mutateAsync: logout } = useLogoutMutation(fetch);

  const { darkMode, setDarkMode } = useTheme();

  const { user } = useAuthContext();

  useKeyboardShortcut(
    { code: 'KeyD', modifiers: ['alt'], preventDefault: true },
    () => {
      setDarkMode(!darkMode);
    }
  );

  const [showEasterEgg, setShowEasterEgg] = useState(false);

  function handleEasterEgg() {
    var audio = new Audio(gobble);
    audio.play();
    setShowEasterEgg(!showEasterEgg);
  }

  return (
    <AppLayoutComponent
      menuVisible={sideBarVisible}
      onMenuToggle={setSideBarVisible}
    >
      <AppLayoutComponent.Header
        className={`font-heading items-center justify-between px-4 py-8 bg-white text-black border-b-black border-b`}
      >
        <div className="flex items-center text-lg">
          <Link to="/" className="mr-4 my-auto flex items-center h-[32px]">
            <Logo className="h-full aspect-square" />
          </Link>
          <Link to="/" className="my-auto text-3xl">
            Tur
          </Link>
          {!showEasterEgg && (
            <button
              onClick={() => handleEasterEgg()}
              className="my-auto text-3xl underline-effect"
            >
              n
            </button>
          )}
          <Link to="/" className="my-auto text-3xl">
            key
          </Link>
          {showEasterEgg && (
            <button
              className="underline-effect"
              onClick={() => handleEasterEgg()}
            >
              🦃
            </button>
          )}
          <Dev>
            <AssumeRole />
          </Dev>
        </div>
        <Spacer />
        <div className="relative flex items-end gap-4 h-full">
          <div
            className="my-auto font-body"
            data-for="mode"
            data-tip="Light/Dark"
          ></div>
          <div className="flex items-center h-full">
            <a
              title="Docs"
              data-tour="docs"
              href={config.VITE_DOCS_URL}
              target="_blank"
              rel="noreferrer"
              className="mx-4"
              data-for="docs"
              data-tip="Docs"
            >
              <Books size={24} />
            </a>
          </div>
          <div className="flex items-center h-full " title="Account">
            <Menu placement="left-bottom" button={<User size={24} />}>
              {user && hasRole(user.roles, 'PREMIUM_USER') && (
                <MenuItem href={import.meta.env.VITE_STRIPE_PORTAL_URL}>
                  Manage Subscription
                </MenuItem>
              )}
              <MenuItem
                onAction={async () => {
                  const res = await logout();
                  if (res.success) {
                    window.location.href = config.VITE_LOGIN_URL;
                  }
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </div>
          <ReactTooltip
            id="account"
            effect="solid"
            type="light"
            place="bottom"
          />
        </div>
      </AppLayoutComponent.Header>
      <AppLayoutComponent.Body>
        <Outlet />
      </AppLayoutComponent.Body>
      <AppLayoutComponent.Menu>
        <AppMenu />
      </AppLayoutComponent.Menu>
    </AppLayoutComponent>
  );
};
